export const pluralizeEntries = amount =>
    parseInt(amount, 10) === 1 ? 'Entry' : 'Entries';
